import React from "react";
import { Progress } from "antd";
import styled from "styled-components";

import variableColors from "../../_App.module.scss";
import { invertColor, mixColors } from "../../utils/helpers";

const { appBackgroundColor, primaryColor } = variableColors;

const ProgressContainer = styled.div<{ $borderColor: string; $borderRight: string }>`
  /* //* AntD progress customization */
  div.ant-progress-inner {
    border: ${(props) => `1px solid ${props?.$borderColor}`};
    div.ant-progress-bg {
      border-right: ${(props) => `1px solid ${props?.$borderRight}`};
    }
  }
`;

const TripProgressBar = ({
  showInfo = false,
  bus,
  strokeLinecap = "round",
  realRouteColor,
  width = 10,
}: {
  bus: BusInfo;
  strokeLinecap?: "butt" | "square" | "round";
  realRouteColor: boolean;
  width?: number;
  showInfo?: boolean;
}): JSX.Element => {
  const strokeColor: string = realRouteColor ? bus?.routeInfoAdded?.color : primaryColor;

  //* Testing width onHover!
  const [isHover, setIsHover] = React.useState<boolean>(false);

  return (
    <React.Fragment>
      <ProgressContainer
        onMouseEnter={(): void => setIsHover(true)}
        onMouseLeave={(): void => setIsHover(false)}
        $borderColor={appBackgroundColor}
        $borderRight={strokeColor}
      >
        {bus?.currentProgress || bus?.currentProgress === 0 ? (
          <Progress
            showInfo={showInfo}
            percent={bus?.currentProgress}
            strokeColor={strokeColor}
            strokeLinecap={strokeLinecap}
            size={["default", isHover ? width * 1.2 : width || 10]}
            trailColor={
              realRouteColor ? `${mixColors(invertColor(strokeColor), appBackgroundColor, 70)}80` : appBackgroundColor
            }
          />
        ) : null}
      </ProgressContainer>
    </React.Fragment>
  );
};

export default TripProgressBar;
